import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>Page Introuvable</h1>
    </div>
  );
};

export default NotFound;
